// @flow
import React, { Component } from 'react';
import { Grid, Form } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import './TreatmentActionForm.scss';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import _ from 'lodash';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  subActionIndex: number,
  onModelChange: (_?: Object) => void,
  handleInputChange: Function,
  handleControlBlur: Function,
  };

@formComponent()
export default class ActionAwardNFTForm extends Component {
  props: Props;

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.awardNFTPayload.web3EventName`}
                {...this.props}
              >
                <Form.Input
                  required
                  label={'Web3 Event Name'}
                  value={_.get(model.nodes[currentNode].data[subActionIndex], 'meta.awardNFTPayload.web3EventName')}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
